import * as React from "react";
import { Input, Col, Form, Checkbox, Row } from "antd";

import { FormInstance } from "antd/lib/form";
import { TIndexTypeGroupPresentationModel } from "../../presenter/model/IndexTypeGroupPresentationModel";
import { TGroupTreePresentationModel } from "../../presenter/model/GroupTreePresentationModel";
import { IIndexTypeCategory } from "../../model/IndexTypeCategory";
import TextArea from "antd/lib/input/TextArea";

const FormFields = {
  ID: "id",
  CODE: "code",
  NAME: "name",
  PARENT_ID: "parentId",
  INDEX_TYPE_CATEGORY_ID: "indexTypeCategoryId",
  VALID: "valid",
  DESCRIPTION: "description"
};

const IndexTypeGroupForm = ({
  translate,
  form,
  rowData,
  category,
  indexTypeGroups
}: {
  translate: any;
  form: FormInstance;
  rowData?: TIndexTypeGroupPresentationModel;
  category: IIndexTypeCategory;
  indexTypeGroups: TGroupTreePresentationModel;
}) => {
  return (
    <Form layout={"vertical"} form={form}>
      <Form.Item
        name={FormFields.ID}
        initialValue={rowData?.id}
        style={{ display: "none" }}
      >
        <Input />
      </Form.Item>

      <Form.Item
        name={FormFields.INDEX_TYPE_CATEGORY_ID}
        initialValue={category.id}
        style={{ display: "none" }}
      ></Form.Item>

      <Row gutter={16} className={"content-section-modal-emphasize"}>
        <Col lg={22} sm={21} xs={20}>
          <Form.Item
            label={translate("editors.index_type_groups.code")}
            className={"mb-0"}
            name={FormFields.CODE}
            initialValue={rowData?.code}
            rules={[
              {
                required: true,
                message: translate(
                  "editors.index_type_groups.required_messages",
                  {
                    field: translate("editors.index_type_groups.code")
                  }
                )
              }
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col
          lg={2}
          sm={3}
          xs={4}
          style={{
            display: "flex",
            marginTop: 20,
            alignItems: "center"
          }}
        >
          <Form.Item
            label={translate("editors.index_type_groups.valid")}
            className={"png-form-item-horizontal-checkbox "}
            name={FormFields.VALID}
            valuePropName={"checked"}
            initialValue={rowData?.valid ?? true}
          >
            <Checkbox />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16} className={"content-section-modal-borderless pb-0"}>
        <Col xs={24} sm={24}>
          <Form.Item
            label={translate("editors.index_type_groups.name")}
            name={FormFields.NAME}
            initialValue={rowData?.name}
            rules={[
              {
                required: true,
                message: translate(
                  "editors.index_type_groups.required_messages",
                  {
                    field: translate("editors.index_type_groups.name")
                  }
                )
              }
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24}>
          <Form.Item
            label={translate("editors.index_type_groups.description")}
            className={"mb-0"}
            name={FormFields.DESCRIPTION}
            initialValue={rowData?.description}
          >
            <TextArea />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default IndexTypeGroupForm;
